import React from 'react';
import {  SideNav } from 'app-components';
import { useAppSelector } from '@hooks/index';
import { ConditionalRendering } from '../conditional-rendering';

const IssuerSidebar = () => {
    const {
        encIssuerId,
        hiosIssuerId,
        ssioEnabled,
        enableFeaturedPlans,
        turquoisePlansEnabled
    } =  useAppSelector(state => state.featurePlan);
    return (
        <aside className="desktop:grid-col-3" id="gi-sidebar" data-testid="gi-issuer-sidebar">
            <SideNav>
                <SideNav.Header labelId="issuer.label.about.issuer" />
                <SideNav.Item>
                    <SideNav.Link labelId="issuer.label.details" name="issuer-details" url={`/hix/admin/issuer/details/${encIssuerId}`} />
                    <SideNav.Link labelId="issuer.label.roles" name="roles" url={`/hix/admin/issuer/representative/manage/${encIssuerId}`}/>
                    <SideNav.Link labelId="issuer.label.companyProfile" name="company_profile" url={`/hix/admin/issuer/company/profile/${encIssuerId}`}/>
                    <SideNav.Link labelId="issuer.label.individualMarketProfile" name="individual_market_profile" url={`/hix/admin/issuer/market/individual/profile/${encIssuerId}`}/>
                    <SideNav.Link labelId="issuer.label.certificationStatus" name="certification_status" url={`/hix/admin/issuer/certification/status/${encIssuerId}`}/>
                    <SideNav.Link labelId="issuer.label.issuerHistory" name="issuer_history" url={`/hix/admin/issuer/history/${encIssuerId}`}/>
                    <ConditionalRendering isTrue={enableFeaturedPlans}>
                        <SideNav.Link labelId="issuer.label.featurePlan" name="feature_plan" url={`/hix/admin/issuer/feature/plan/${encIssuerId}`} isSelectedDefault/>
                    </ConditionalRendering>
                    <SideNav.Link labelId="issuer.label.planIdCrosswalk" name="plan_id_crosswalk" url={`/hix/admin/issuer/crossWalkStatus/${encIssuerId}`}/>
                    <SideNav.Link labelId="issuer.label.medicalLossRatio" name="medical_loss_ratio" url={`/hix/admin/issuer/medicalLossRatio/${encIssuerId}`}/>
                    <SideNav.Link labelId="issuer.label.planUrls" name="plan_urls" url={`/hix/admin/issuer/planURLStatus/${encIssuerId}`}/>
                    <ConditionalRendering isTrue={turquoisePlansEnabled}>
                        <>
                            <SideNav.Link labelId="issuer.label.torquoiseTemplate" name="torquoise_template" url={`/hix/admin/issuer/turquoiseStatus/${encIssuerId}"/`}/>
                            <SideNav.Link labelId="issuer.label.silverToGoldMapping" name="silver_to_gold_mapping" url={`/hix/admin/issuer/metalTierTransition/Status/${encIssuerId}`}/>
                        </>
                    </ConditionalRendering>
                    <ConditionalRendering isTrue={ssioEnabled}>
                        <SideNav.Link labelId="issuer.label.issuerEdiTesting" name="issuer_edi_testing" url={`/hix/issuer-edi-testing/${hiosIssuerId}`}/>
                    </ConditionalRendering>
                    <SideNav.Link labelId="issuer.label.paymentConfiguration" name="payment_configuration" url={`/hix/admin/issuer/paymentConfiguration/${encIssuerId}`}/>
                </SideNav.Item>
            </SideNav>     
        </aside>
    );
};

export default IssuerSidebar;